(function () {
  const GA_MEASUREMENT_ID = 'G-W1C2QMXJB1';
  let gaLoaded = false;
  let gtagReady = false;
  let viewItemSent = false;
  const pendingEvents = [];

  const isProduct =
    document.body.classList.contains('template-product') ||
    window.location.pathname.indexOf('/products/') !== -1;

  function onReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  }

  function onLoad(callback) {
    if (document.readyState === 'complete') {
      callback();
    } else {
      window.addEventListener('load', callback, { once: true });
    }
  }

  function requestIdleSafe(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, timeout ? { timeout: timeout } : undefined);
    } else {
      setTimeout(callback, timeout || 1);
    }
  }

  function safeNumber(value, fallback) {
    const n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function getCurrency() {
    return window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : 'AUD';
  }

  function ensureGtag() {
    return typeof window.gtag === 'function';
  }

  function flushPendingEvents() {
    if (!ensureGtag()) return;

    while (pendingEvents.length) {
      const event = pendingEvents.shift();
      window.gtag('event', event.name, event.params || {});
    }
  }

  function sendEvent(name, params) {
    if (ensureGtag()) {
      window.gtag('event', name, params || {});
      return;
    }

    pendingEvents.push({ name, params: params || {} });
  }

  function loadGA() {
    if (gaLoaded) return;
    gaLoaded = true;

    if (typeof window.gtag === 'function') {
      gtagReady = true;
      flushPendingEvents();
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src =
      'https://www.googletagmanager.com/gtag/js?id=' +
      encodeURIComponent(GA_MEASUREMENT_ID);

    script.onload = function () {
      window.dataLayer = window.dataLayer || [];

      function gtag() {
        window.dataLayer.push(arguments);
      }

      window.gtag = gtag;
      gtagReady = true;

      gtag('js', new Date());
      gtag('config', GA_MEASUREMENT_ID, {
        anonymize_ip: true,
        send_page_view: true
      });

      flushPendingEvents();
    };

    document.head.appendChild(script);
  }

  function initManualGA() {
    function triggerLoad() {
      requestIdleSafe(loadGA, 1500);
    }

    ['click', 'touchstart'].forEach(function (eventName) {
      window.addEventListener(eventName, triggerLoad, {
        once: true,
        passive: true
      });
    });

    onLoad(function () {
      requestIdleSafe(loadGA, 5000);
    });
  }

  function getSelectedVariant(product, form) {
    if (!product || !product.variants || !product.variants.length) return null;

    const variantIdInput = form
      ? form.querySelector('[name="id"]')
      : document.querySelector('form[action^="/cart/add"] [name="id"]');

    const selectedVariantId = variantIdInput && variantIdInput.value
      ? String(variantIdInput.value)
      : null;

    return (
      product.variants.find(function (v) {
        return String(v.id) === selectedVariantId;
      }) || product.variants[0]
    );
  }

  function buildItem(product, variant, quantity) {
    const price = safeNumber(variant.price, 0) / 100;

    return {
      item_id: variant.sku || String(variant.id || product.id),
      item_name: product.title,
      item_brand: product.vendor || undefined,
      item_category: product.type || undefined,
      item_variant: variant.title || undefined,
      price: price || undefined,
      quantity: quantity || 1
    };
  }

  function initViewItemTracking() {
    if (!isProduct) return;

    onReady(function () {
      const product = window.meta && window.meta.product;
      if (!product) return;

      const variant = getSelectedVariant(product, null);
      if (!variant) return;

      const price = safeNumber(variant.price, 0) / 100;
      const compareAt = safeNumber(variant.compare_at_price, 0) / 100;
      const item = buildItem(product, variant, 1);

      function sendViewItem() {
        if (viewItemSent) return;
        viewItemSent = true;

        sendEvent('view_item', {
          currency: getCurrency(),
          value: price || compareAt || undefined,
          items: [item]
        });
      }

      function scheduleSend() {
        requestIdleSafe(sendViewItem, 1800);
      }

      if (ensureGtag() || gtagReady) {
        scheduleSend();
      } else {
        onLoad(function () {
          requestIdleSafe(function () {
            loadGA();
            scheduleSend();
          }, 1600);
        });
      }
    });
  }

  function initAddToCartTracking() {
    if (!isProduct) return;

    onReady(function () {
      const cartForm = document.querySelector('form[action^="/cart/add"]');
      const product = window.meta && window.meta.product;

      if (!cartForm || !product) return;

      cartForm.addEventListener('submit', function () {
        const variant = getSelectedVariant(product, cartForm);
        if (!variant) return;

        const quantity = safeNumber(
          cartForm.querySelector('[name="quantity"]') &&
          cartForm.querySelector('[name="quantity"]').value,
          1
        );

        const price = safeNumber(variant.price, 0) / 100;

        requestIdleSafe(function () {
          sendEvent('add_to_cart', {
            currency: getCurrency(),
            value: (price || 0) * quantity,
            items: [buildItem(product, variant, quantity)]
          });
        }, 1200);
      });
    });
  }

  initManualGA();

  if (isProduct) {
    initViewItemTracking();
    initAddToCartTracking();
  }
})();